<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h3>{{ phase }} Phase </h3>
      </div>
      <div class="card-body">
        <validation-observer ref="simpleRules">
          <b-form>
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <label for="type">Design Type</label>
                  <a
                      v-if="parentObj3 && parentObj3.designType"
                      :href="parentObj3 ? parentObj3.designType.url : '' "
                    target="_blank"
                  ><small style=" float: right;">View
                    Old File?</small></a>
                  <validation-provider
                    #default="{ errors }"
                    name="designType"
                    rules=""
                  >
                    <b-form-file
                      v-model="phaseThree.designType"
                      :file-name-formatter="formatNames"
                      accept=".pdf"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <label for="waiverDocument">Waiver Document</label>
                  <a
                      v-if="parentObj3 && parentObj3.waiverDocument"
                      :href="parentObj3 ? parentObj3.waiverDocument.url : '' "
                    target="_blank"
                  ><small
                    style=" float: right;"
                  >View Old File?</small></a>
                  <validation-provider
                    #default="{ errors }"
                    name="waiverDocument"
                    :rules="customRules"
                  >
                    <b-form-file
                      v-model="phaseThree.waiverDocument"
                      :file-name-formatter="formatNames"
                      accept=".pdf"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group>
                  <label for="completionForm">Completion Form</label>
                  <a
                      v-if="parentObj3 && parentObj3.completionForm"
                      :href="parentObj3 && parentObj3.completionForm && parentObj3.completionForm.url "
                      target="_blank"
                  ><small style=" float: right;">View Old File?</small></a>
                  <validation-provider
                      #default="{ errors }"
                      name="completionForm"
                      :rules="customRules"
                  >
                    <b-form-file
                        v-model="phaseThree.completionForm"
                        :file-name-formatter="formatNames"
                        accept=".pdf"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                md="12"
                style="display: flex; justify-content: end;"
              >
                <button
                  id="submit-phase3"
                  type="button"
                  class="btn btn-outline-primary mt-2"
                  @click.prevent="validationForm"
                >
                  <feather-icon
                    icon="Edit2Icon"
                    class="mr-25"
                  />
                  Submit
                </button>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'

import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BFormDatepicker, BFormFile,
} from 'bootstrap-vue'
import {
  required, email, confirmed, password,
} from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import { codeBasic } from './code'
import PhaseThreeService from '@/services/project/phaseThreeService'

import designTypesService from '@/services/settings/designTypesService'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    vSelect,
    BFormFile,
    BFormDatepicker,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
  },
  props: ['phase', 'parentObj3'],
  data() {
    return {
      customRules: 'required',
      loading: false,
      phaseThree: {
        designType: null,
        waiverDocument: null,
        completionForm: null,
      },
      required,
      password,
      email,
      confirmed,
    }
  },
  mounted() {
    this.getdesignTypesService()
    this.$watch(() => this.tab, val => {
      this.choosenTab = val
    })
    this.$watch(() => this.parentObj3, parentObj => {
      if (parentObj !== null) {
        this.customRules = ''
        this.phaseThree = {
          designType: null,
          completionForm: null,
          waiverDocument: null,
        }
      }
    })
  },
  methods: {
    getdesignTypesService() {
      this.loading = true
      designTypesService.index()
        .then(response => {
          this.loading = false
          this.designTypes = response.data.data
        })
    },
    formatNames(files) {
      if (files.length === 1) {
        return files[0].name
      }
      return `${files.length} files selected`
    },
    validationForm() {
      document.getElementById('submit-phase3').setAttribute('disabled', 'disabled')

      this.loading = true
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          PhaseThreeService.post(this.$route.params.id, this.phaseThree)
            .then(response => {
              if (response && response.status === 200) {
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Success',
                    icon: 'CheckIcon',
                    variant: 'success',
                    text: 'Phase Three Is Updated Successfully !',
                  },
                })
              }
              this.$emit('refreshPanel', 'true')
              this.loading = false
            })
          setTimeout(function(){
            document.getElementById('submit-phase3').removeAttribute('disabled')
          }, 5000)
        }
        else{
          document.getElementById('submit-phase3').removeAttribute('disabled')
        }
      }).catch(error => {
        Promise.reject(error)
        setTimeout(function(){
          document.getElementById('submit-phase3').removeAttribute('disabled')
        }, 5000)
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
